import { InjectionToken } from '@angular/core';

/**
 * Injection token for the translation base URL.
 * This token is used to inject the base URL for loading translation files.
 *
 * The token is provided in the root injector, making it available throughout the application.
 * The default value for the base URL is '/assets/i18n', which can be overridden if needed.
 */
export const TRANSLATION_BASE_URL = new InjectionToken<string>('Translation Base URL', {
  providedIn: 'root', // Makes this token available application-wide.

  /**
   * Factory function to provide the default value for the translation base URL.
   * This can be replaced with a different URL based on environment or configuration.
   *
   * @returns The base URL for translation files.
   */
  factory: () => '/assets/i18n', // Default value for translation files location
});
